<template>
  <div :class="itemClasses">
    <div :class="headerClasses" @click="$_toggle">
      <a :class="{collapsed: !isActive}"></a>
      <slot></slot>
    </div>
    <t-collapse-transition>
      <div :class="contentClasses" v-show="isActive">
        <div :class="boxClasses" :style="padding">
          <slot name="content"></slot>
        </div>
      </div>
    </t-collapse-transition>
  </div>
</template>
<script>
const prefixCls = 'collapse'

export default {
  name: 'Panel',
  props: {
    name: {
      type: String
    },
    noPadding: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      index: 0, // use index for default when name is null
      isActive: false,
      padding: {}
    }
  },
  computed: {
    itemClasses() {
      return [
        `${prefixCls}-item card`,
        {
          [`${prefixCls}-item-active`]: this.isActive
        }
      ]
    },
    headerClasses() {
      return `card-header`
    },
    contentClasses() {
      return `card-block`
    },
    boxClasses() {
      return `${prefixCls}-content-box`
    }
  },
  watch: {
    isActive(val) {
      if (this.noPadding) {
        this.padding = {
          padding: 0
        }
      }
    }
  },
  methods: {
    // 添加私有方法
    $_toggle() {
      this.$parent.onCollapseToggle({
        name: this.name || this.index,
        isActive: this.isActive
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// panel.vue?750d0fd7